import React, { useState } from "react";
import { useDispatch, useSelector } from "@/types/store";
import * as viewReducer from "@/containers/View/reducer";
import { getFilterIntermediateDatasets, updateFilterIntermediateDatasets } from "@/containers/Sense/reducer";
import styles from "@/components/Home/Utils/utils.module.css";
import { isEnabled } from "@/utils/featureFlags";
const ViewOptions = () => {
    const initDefaultView = isEnabled("spark-with-partners")
        ? "chat"
        : isEnabled("enable-agents-templates-view")
            ? "templates"
            : "datasets";
    const dispatch = useDispatch();
    const updateDatasetViewMode = (viewMode) => dispatch(viewReducer.updateDatasetViewMode(viewMode));
    const datasetViewMode = useSelector((state) => viewReducer.getDatasetViewMode(state));
    const [defaultView, updateDefaultView] = useState(localStorage.getItem("default_view") || initDefaultView);
    const handleDefaultView = (value) => {
        updateDefaultView(value);
        localStorage.setItem("default_view", value);
    };
    const filterIntermediateDatasets = useSelector((state) => getFilterIntermediateDatasets(state));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement("div", { style: { color: "var(--dark-grey)" } }, "Set Home View"),
            isEnabled("enable-agents-templates-view") && (React.createElement("div", { onClick: () => handleDefaultView("templates"), className: styles.datasetViewOption },
                React.createElement("input", { type: "radio", checked: defaultView === "templates", disabled: !localStorage, readOnly: true }),
                React.createElement("span", { className: styles.datasetViewOptionsLabel }, "Agent Templates"))),
            (isEnabled("chat-aible-consumer") || isEnabled("chat-aible")) && (React.createElement("div", { onClick: () => handleDefaultView("chat"), className: styles.datasetViewOption },
                React.createElement("input", { type: "radio", checked: defaultView === "chat", disabled: !localStorage, readOnly: true }),
                React.createElement("span", { className: styles.datasetViewOptionsLabel }, "Chat"))),
            React.createElement("div", { onClick: () => handleDefaultView("datasets"), className: styles.datasetViewOption },
                React.createElement("input", { type: "radio", checked: defaultView === "datasets", disabled: !localStorage, readOnly: true }),
                React.createElement("span", { className: styles.datasetViewOptionsLabel }, "Datasets"))),
        isEnabled("sense-list-view") && (React.createElement("div", null,
            React.createElement("div", { style: { color: "var(--dark-grey)" } }, "Data view options"),
            React.createElement("div", { onClick: () => {
                    if (datasetViewMode !== "TILE") {
                        updateDatasetViewMode("TILE");
                    }
                }, className: styles.datasetViewOption },
                React.createElement("input", { type: "radio", checked: datasetViewMode === "TILE", readOnly: true, style: { marginTop: 0 } }),
                React.createElement("span", { className: styles.datasetViewOptionsLabel }, "Tile")),
            React.createElement("div", { onClick: () => {
                    if (datasetViewMode !== "LIST") {
                        updateDatasetViewMode("LIST");
                    }
                }, className: styles.datasetViewOption },
                React.createElement("input", { type: "radio", checked: datasetViewMode === "LIST", readOnly: true, style: { marginTop: 0 } }),
                React.createElement("span", { className: styles.datasetViewOptionsLabel }, "List")),
            React.createElement("div", { onClick: () => {
                    dispatch(updateFilterIntermediateDatasets(!filterIntermediateDatasets));
                }, className: styles.datasetViewOption },
                React.createElement("input", { type: "checkbox", checked: filterIntermediateDatasets, readOnly: true, style: { marginTop: 0 } }),
                React.createElement("span", { className: styles.datasetViewOptionsLabel }, "Filter Intermediate Datasets"))))));
};
export default ViewOptions;
